import { useTranslation } from 'react-i18next';
import { appConfig, type ChannelEntityType, hierarchy } from 'shared';
import { useOnlineManager } from '~/hooks/use-online-manager';
import { ResponsiveSelect } from '~/modules/common/form-fields/responsive-select';

interface SelectRoleProps {
  /** Restrict options to this channel entity's role vocabulary; omit for system roles. */
  entityType?: ChannelEntityType;
  onChange: (value?: string) => void;
  value?: string;
  className?: string;
}

/** A role filter whose "All" option reads and writes `undefined`. */
export function SelectRole({ entityType, onChange, value, className }: SelectRoleProps) {
  const { t } = useTranslation();
  const isOnline = useOnlineManager();

  const roleOptions = entityType ? hierarchy.getRoles(entityType) : appConfig.systemRoles;

  const options = [{ value: 'all', label: t('c:all') }, ...roleOptions.map((role) => ({ value: role, label: t(role) }))];

  return (
    <ResponsiveSelect
      options={options}
      value={value ?? 'all'}
      onChange={(role) => onChange(role === 'all' ? undefined : role)}
      placeholder={t('c:placeholder.select_role')}
      title={t('c:role')}
      showTitle
      className={className}
      disabled={!isOnline}
    />
  );
}
